import { useEffect } from '@hfe/max';
const isWeb = true;
export function useThrottle(ms, callback, deps, needIsWeb) {
    let timeout = null;
    useEffect(() => {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback && callback();
        }, ms); // 秒后消失
        return () => {
            timeout && clearTimeout(timeout);
        };
    }, deps);
}
